import type { Nullable } from '@symfa-inc/providence-verizon-types';
import type { TabProps } from './models/tab-props';
import { Route } from './route';

export class Tab<PropsType = any> extends Route {
  #isLink: boolean;
  #componentProps?: PropsType;
  #pathToOpenInNewWindow?: (key?: Nullable<string>) => string;

  constructor({
    isLink = false,
    componentProps,
    pathToOpenInNewWindow,
    ...props
  }: TabProps<PropsType>) {
    super(props);

    this.#componentProps = componentProps;

    this.#isLink = isLink;

    this.#pathToOpenInNewWindow = pathToOpenInNewWindow;
  }

  // GETTERS & SETTERS
  get isLink(): boolean {
    return this.#isLink;
  }

  get componentProps(): any {
    return this.#componentProps;
  }

  get pathToOpenInNewWindow():
    | ((key?: Nullable<string>) => string)
    | undefined {
    return this.#pathToOpenInNewWindow;
  }

  // METHODS
  setLink(isLink: boolean = true): this {
    this.#isLink = isLink;

    return this;
  }

  setComponentProps(componentProps: any): this {
    this.#componentProps = componentProps;

    return this;
  }

  setPathToOpenInNewWindow(
    pathToOpenInNewWindow?: (key?: Nullable<string>) => string,
  ): this {
    this.#pathToOpenInNewWindow = pathToOpenInNewWindow;

    return this;
  }
}
